import { render, staticRenderFns } from "./QAForm.vue?vue&type=template&id=05a70167&"
import script from "./QAForm.vue?vue&type=script&lang=js&"
export * from "./QAForm.vue?vue&type=script&lang=js&"
import style0 from "./QAForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports